  <div class="container app" *ngIf="loadOtherComponents">
    <router-outlet></router-outlet>
  </div>
